import { Text, View } from '@react-pdf/renderer'
import React from 'react'
import { PDF_BLOCK_HEADING, PDF_BLOCK_TEXT, PDF_GRAY } from '../../../../constants'
import PdfTextBlockBottom from '../TextBlocks/PdfTextBlockBottom'
import PdfTextBlockTop from '../TextBlocks/PdfTextBlockTop'

const HeaderDetails = ({data}) => {
    return (
        <View
            style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "stretch",
                padding: "10px",
                backgroundColor: "#1d71b8",
                marginBottom: "15px"
            }}
        >
            <View
                style={{
                    width: "16.66%",
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <PdfTextBlockBottom title="Total" text="*" disableRightBorder={true} />
            </View>
            <View
                style={{
                    width: "16.66%",
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <PdfTextBlockBottom title="Available" text="*" disableRightBorder={true} />
            </View>
            <View
                style={{
                    width: "16.66%",
                    display: "flex",
                    flexDirection: "column",
                    marginRight: "10px"
                }}
            >
                <PdfTextBlockBottom title="Sample Pull" text="*" />
            </View>
            
            <View
                style={{
                    width: "16.66%",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <PdfTextBlockTop title="Critical" text={
                    data.job_meta.total_collective_critical_item ?
                        data.job_meta.total_collective_critical_item
                    :
                        "0"
                    
                } textStyles={{textAlign: "center"}} disableRightBorder={true} />
            </View>
            <View
                style={{
                    width: "16.66%",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <PdfTextBlockTop title="Major" text={
                    data.job_meta.total_collective_major_item ?
                        data.job_meta.total_collective_major_item
                    :
                        "0"
                    
                } textStyles={{textAlign: "center"}} disableRightBorder={true} />
            </View>
            <View
                style={{
                    width: "16.66%",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <PdfTextBlockTop title="Minor" textStyles={{textAlign: "center"}} text={
                    data.job_meta.total_collective_minor_item ?
                        data.job_meta.total_collective_minor_item
                    :
                        "0"
                    
                }  />
            </View>
            
            
        </View>
    )
}

export default HeaderDetails